















import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import HelloWorld from 'modules/core/components/HelloWorld.vue';
import AppHeader from './AppHeader.vue';
import AppSidebar from './AppSidebar.vue';
import { CoreStateInterface } from '../interfaces/coreState';
import SubscriptionAlert from './SubscriptionAlert.vue';
// import AccountConfirmationAlert from './AccountConfirmationAlert.vue';
// import PersonalDataFilledAlert from './PersonalDataFilledAlert.vue';

@Component({
  components: {
    AppHeader,
    AppSidebar,
    HelloWorld,
    SubscriptionAlert,
    // AccountConfirmationAlert,
    // PersonalDataFilledAlert,
  },
})
export default class App extends Vue {
  @State('core') public core!: CoreStateInterface;

  get hidden() {
    return this.core.hideSidebar;
  }
}
